var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-inner"},[_c('iframe',{staticClass:"output-iframe",attrs:{"src":_vm.url+_vm.datestr,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }